<template>
<div class="chapter">
<div class="inner_page">
<p class="break"> </p>
<h1 class="sgc-1" id="heading_id_2">Contents</h1>
<p class="tocitem sgc-3"><a class="sgc-2" href="#/Text/05_part1">Part One</a></p>
<p class="tocitem"><span class="sgc-2" href="#/Text/06_part2" title="Link target outside of Sample">Part Two</span></p>
<p class="tocitem"><span class="sgc-2" href="#/Text/07_part3" title="Link target outside of Sample">Part Three</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08_contents.vue?47bc179c